import capitalizeFirst from '../components/common/capitalizeFirst';
import { API, graphqlOperation } from 'aws-amplify';
import * as queries from '../graphql/queries';
import * as mutations from '../graphql/mutations';

function ConvertResponseForSelect(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(([key, value]) => {
        myArray.push({ name: value.name, code: value.id });
    })
    return myArray;
};

function ConvertResponseForEmployeeSelect(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(([key, value]) => {
        myArray.push({ name: value.employee_name + " (" + value.employee_code + ")" , code: value.id, schoolId: value.school_id });
    })
    return myArray;
};

function ConvertResponseForEmployee(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(([key, value]) => {
        myArray.push({ name: value.employee_name + " (" + value.employee_code + ")" , code: value.id });
    })
    return myArray;
};

function ConvertEnumToArray(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(([key]) => {
        myArray.push({ label: capitalizeFirst(key.toLowerCase()), value: key });
    })
    return myArray;

};





function GetSingleValueFromResponse(responses, keyName) {
    var returnValue = ''
    var myObject = Object.entries(responses);
    myObject.forEach(([key, value]) => {
        if (keyName === key) {
            returnValue = value;
            return true;
        }
    })
    return returnValue;

}

function GetValueFromArray(myArray, keyName) {
    for (var key in myArray) {
        if (myArray[key]['Name'] === keyName) {
            return myArray[key]['Value'];
        }
    }
}


function ObjectLength(object) {
    var length = 0;
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            ++length;
        }
    }
    return length;
};

//remove duplicate item from array
function checkDuplicates(currentArray) {
    return currentArray.filter((item,
        index) => currentArray.indexOf(item) === index && item !== "");
};

//*Get response from key
const getResponseFromKey = async (currentArray, KeyArray, employeeId, employeePayRate) => {

    let finalArray = []
    for (var i = 0; i < KeyArray.length; i++) {

        let getCurrentResponseFromKey = currentArray.filter((item) => item.employeeName === KeyArray[i])
        let getTotalHours = getCurrentResponseFromKey.map((item) => item.totalHourAndMinutesDisplay)
        let employeeTotalHours = getTotalHours.reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        let data = {
            "employeeName": KeyArray[i],
            "employeeId": employeeId,
            "employeeResponse": getCurrentResponseFromKey,
            // "employeeType": employeeType,
            "employeeTotalHours": employeeTotalHours,
            "employeePayRate": employeePayRate,
            "employeeIndex": ""
        }
        finalArray.push(data)

        if (i === KeyArray.length - 1) {
            return finalArray
        }
    }
};


const getResponseFromKeyCertifiedAdmin = async (currentArray, KeyArray, employeeId, employeeType) => {

    let finalArray = []
    for (var i = 0; i < KeyArray.length; i++) {

        let getCurrentResponseFromKey = currentArray.filter((item) => item.employeeName === KeyArray[i])

        let data = {
            "employeeName": KeyArray[i],
            "employeeId": employeeId,
            "employeeResponse": getCurrentResponseFromKey,
            "employeeType": employeeType,
        }
        finalArray.push(data)

        if (i === KeyArray.length - 1) {
            return finalArray
        }
    }
};


function ObjectToArray(object) {
    let data = [];
    for (const [key, value] of Object.entries(object)) {
        data[key] = value;
    }
    return data;
}
function validateFileExtension(file_field, allowedExtensions) {
    let flag = false;
    let extension = file_field.substr(file_field.lastIndexOf('.') + 1).toLowerCase();
    if (allowedExtensions.indexOf(extension) === -1) {
        flag = true;
    }
    return flag;
}

function ConvertResponseForSelectWithRefCode(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(async ([key, value]) => {
        myArray.push({ name: value.name + " (" + value.code + ")", code: value.id });
    })
    return myArray;
};


function ConvertResponseForSelectWithRefCodedropdown(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(async ([key, value]) => {
        myArray.push({ name: value.name, code: value.id });
    })
    return myArray;
};

function ConvertResponseOfNameCodeForSelect(responses, defaultArray = []) {
    var myArray = [];
    if (!Array.isArray(defaultArray)) { myArray.push(defaultArray); }
    var objectArray = Object.entries(responses);
    objectArray.forEach(async ([key, value]) => {
        myArray.push({ label: value.name, value: value.code });
    })
    return myArray;
};

export function formatDateToDdMmYyyy(inputDate) {
    const date = new Date(inputDate);
  
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
  
    return `${day}/${month}/${year}`;
  };


  
  export function removeDuplicateApprover (employeeResponses){
   // Grouping by email of employee in the school
		const groupedByEmail = employeeResponses.reduce((acc, obj) => {
            const email = obj.email;
            if (!acc[email]) {
              acc[email] = [];
            }
            acc[email].push(obj);
  
            return acc;
            }, {});
    
          console.log(groupedByEmail,"groupedByEmail")
          // Order each group by createdAt date in descending order
          for (const email in groupedByEmail) {
            groupedByEmail[email].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
          }
          // Create a list with unique email addresses and the latest object for each email
          const uniqueEmailList = Object.keys(groupedByEmail).map((email) => groupedByEmail[email][0]);
  
          // Display the result
          console.log(uniqueEmailList,"uniqueEmailList1");
          return uniqueEmailList;
  };
  
  const graphQLGetAllData = async (tableName, filter = []) => {
    filter.push({ _deleted: { attributeExists: false } })
    let allData = [];
    let nextToken4 = null;
    let hasMoreData = true;
    while (hasMoreData) {
		try{
        const result2 = await API.graphql(graphqlOperation(queries[tableName], { filter: { and: filter }, limit: 3000, nextToken: nextToken4 }));
        const { items, nextToken: newNextToken } = result2.data[tableName];
        allData = [...allData, ...items];
        console.log("tableName", tableName)
        nextToken4 = newNextToken;
        hasMoreData = nextToken4 !== null && nextToken4 !== undefined ? nextToken4 : false;
		}catch(e){
			return allData;
		}
    }
    return allData;
}

const graphQLFindRecordById = async (tableName, id) => {
    var result = []
    if (id) {
        result = await API.graphql({ query: queries[tableName], variables: { id: id } });
        result = result.data ? result.data[tableName] : []
    }
    return result;
}




const fetchGraphqlPaginatedRecords = async (query, filter, sort, limit, resultKey, checkDeleted = true) => {
        let allRecords = [];
        let nextToken = null;
        let variables = checkDeleted ? { _deleted: { eq: null } } : {};
        // Add to query variables that are not null
        filter && (variables.filter = filter);
        limit && (variables.limit = 3000);
        sort && (variables.sort = sort);
        do {
            variables.nextToken = nextToken;
            const result = await API.graphql(graphqlOperation(query, variables));
            const { items, nextToken: newNextToken } = result.data[resultKey];

            allRecords = [...allRecords, ...items];
            nextToken = newNextToken;
        } while (nextToken);
        return allRecords.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
    };

export { ConvertResponseForSelect, getResponseFromKeyCertifiedAdmin, ConvertEnumToArray, GetValueFromArray, GetSingleValueFromResponse, ObjectLength, ObjectToArray, validateFileExtension, checkDuplicates, getResponseFromKey, ConvertResponseForSelectWithRefCode, ConvertResponseForSelectWithRefCodedropdown, ConvertResponseForEmployeeSelect, ConvertResponseOfNameCodeForSelect,ConvertResponseForEmployee, graphQLGetAllData, graphQLFindRecordById,fetchGraphqlPaginatedRecords  };